<template>
  <v-list-item class="no-tag-found">
    <v-list-item-title class="no-tag-found__title">
      <span
        v-html="
          t('Type the value and press <kbd>enter</kbd> to create a tag. Tag will be stored for future settings')
        "
      />
    </v-list-item-title>
  </v-list-item>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';

const { t } = useI18n();
</script>

<style lang="scss">
.no-tag-found {
  &__title {
    white-space: normal;
    overflow: visible;
    display: inline;
    min-height: 24px;
    height: auto;
  }
}
</style>
